import { useSearchParams } from 'react-router-dom';

const useQueryParam = (queryKey: string) => {
  const [searchParams] = useSearchParams();

  return searchParams.get(queryKey);
};

export default useQueryParam;
